import { QueryOptions } from 'react-query';
import { getPartners } from './partners.api';
import { PartnersList } from './partners.schema';

export const PARTNERS_QUERY_KEY_PREFIX = 'partners';

export const getPartnersQuery = (): QueryOptions<PartnersList> => ({
  queryKey: [PARTNERS_QUERY_KEY_PREFIX],
  queryFn: () => getPartners(),
});
